export const convertFocalPointToObjectPosition = (focalPoint: number) => {
	// Sigmoid function tuned to map Dato focal point values to correct looking object-position values
	return 100 / (1 + Math.exp(-focalPoint * 8 + 4));
};
